import React, {Component} from "react";
import "./Nav.css"
import {Link, Router} from "react-router-dom";
import Authentication from "../authentication/Authentication";


export default class Nav extends Component {

    constructor(props) {
        super(props);

        this.authentication = new Authentication();
    }

    render() {
        return (
            <div className={"nav-bar"}>
                <Router history={this.props.history}>
                    <Link to="/trypi" data-testid="navbar.link.trypi">
                        <button value="trypi" className="normal" data-testid="navbar.button.trypi">Try Pi</button>
                    </Link>
                    <Link to="/academy"  data-testid="navbar.link.academy">
                        <button value="academy" className="normal" data-testid="navbar.button.academy">Academy</button>
                    </Link>
                    <Link to="/pisaas"  data-testid="navbar.link.pisaas">
                        <button value="pisaas" className={"normal"} data-testid="navbar.button.pisaas">PiSaaS</button>
                    </Link>
                    {this.authentication.isAdmin() ?
                        <Link to="/admin"  data-testid="navbar.link.admin">
                            <button value="admin" className="normal" data-testid="navbar.button.admin">Admin</button>
                        </Link> :
                        <></>
                    }
                </Router>
            </div>
        );
    }
}
